import { tagUrl } from '@/urls'
import { MIDTERMS_TAG_SLUG } from '@/constants/midterms'

/**
 * The election the home banner announces: the hero's opening slide on
 * desktop, a card in the feed below that breakpoint. One object so both read
 * the same copy and link.
 */
export const MIDTERM_EVENT = {
  id: 'us-midterms-2026',
  eyebrowKey: 'midterm_banner.eyebrow',
  titleKey: 'midterm_banner.title',
  subtitleKey: 'midterm_banner.subtitle',
  ctas: [{ id: 'markets', labelKey: 'midterm_banner.cta_markets', to: tagUrl(MIDTERMS_TAG_SLUG), primary: true }],
}
